export default __webpack_public_path__ + "static/media/vada.cd433967.png";